export const questionnaireQuestionTypes = {
    MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
    CHECKBOX: 'CHECKBOX',
    FREE_TEXT: 'FREE_TEXT',
    RATING_SCALE: 'RATING_SCALE',
}

export const questionnaireInputFieldType = {
    MULTIPLE_CHOICE: 'radio',
    CHECKBOX: 'checkbox',
}



export const defaultQuestionType = questionnaireQuestionTypes.MULTIPLE_CHOICE;

export const questionnaireTypes = {
    EXAM: 'EXAM',
    SURVEY: 'SURVEY'
}

// Survey-specific question types
export const surveyQuestionTypes = [
    questionnaireQuestionTypes.MULTIPLE_CHOICE,
    questionnaireQuestionTypes.CHECKBOX,
    questionnaireQuestionTypes.FREE_TEXT,
    questionnaireQuestionTypes.RATING_SCALE
];

// Exam-specific question types
export const examQuestionTypes = [
    questionnaireQuestionTypes.MULTIPLE_CHOICE,
    questionnaireQuestionTypes.CHECKBOX,
    questionnaireQuestionTypes.FREE_TEXT,
];

export const questionsTypesToShowOptions = [
    questionnaireQuestionTypes.MULTIPLE_CHOICE, 
    questionnaireQuestionTypes.CHECKBOX
];